import { set, get } from 'lodash'
import { BaseResource as Resource } from '../defaults/resource'
import editable from '../directives/editable'
import placeholder from '../directives/placeholder'
import withMessages from './with-messages'

export default {
  mixins: [ withMessages ],
  directives: {
    editable,
    placeholder
  },
  props: {
    resource: {
      type: [Object, null],
      default: null
    }
  },
  data () {
    return {
      inlineEditable: []
    }
  },
  methods: {
    handleEditableBlur ({ path, value, resource }) {
      // get resource to edit
      const targetResource = resource || this.resource;

      // check if there is any change
      if (get(targetResource, path) === value) return;

      // Create updated resource
      const update = {...targetResource};
      set(update, path, value)
      
      // update resource locally
      Resource.update({
        where: targetResource.id,
        data: update
      })
      // send message to CMS
      this.resourceEditedMessage({
        resource: targetResource
      })
    },
    getInlineEditables () {
      // Dirty hackaround to get data from directive, probably possible to solve this with refs
      if (!this.$children || !this.$children[0].$children) { return }
      if (!this.$children[0].$children.length) {
        return this.$children[0].inlineEditable
      }
      return this.$children[0].$children[0].inlineEditable
    },
    openEditForm () {
      this.editResourceMessage({
        resource: this.resource,
        inlineEditable: this.getInlineEditables()
      })
    }
  }
}
